import { useEffect, useState } from 'react';
import {
    DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton,
    GridToolbarDensitySelector, GridToolbarExportContainer, GridCsvExportMenuItem, esES,
    GridPrintExportMenuItem, gridClasses
} from '@mui/x-data-grid';
import jwt_decode from "jwt-decode";
import { Alert, Autocomplete, Box, Button, Card, CardContent, CardHeader, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, TextField } from '@mui/material';
import { useDataContext } from '../../contexts/dataContext';
import CloseIcon from '@mui/icons-material/Close';

const csvOptions = { utf8WithBom: true };
const printOptions = {
    hideFooter: true,
    hideToolbar: true,
}

const tipos = [{ id: 'gestion', label: 'Gestión presupuestal' }, { id: 'planeacion', label: 'Planeación presupuestal' }]
const tiposBuscar = ['gestion', 'planeacion']

const CustomExportButton = (props) => (
    <GridToolbarExportContainer {...props}>
        <GridCsvExportMenuItem options={csvOptions} />
        <GridPrintExportMenuItem options={printOptions} />
    </GridToolbarExportContainer>
);

const CustomToolbar = (props) => (
    <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <CustomExportButton />
    </GridToolbarContainer>
);

export default function AvisosListado() {

    const [dataGestion, setDataGestion] = useState({ columns: [], rows: [] })
    const [pageSize, setPageSize] = useState(10)
    const [openDialog, setOpenDialog] = useState(false)
    const { esAsistente, esJefe, usuario } = useDataContext()

    const [entidadesSeleccionadas, setEntidadesSeleccionadas] = useState([])
    const [tipo, setTipo] = useState({ id: null, label: '' })
    const [entidades, setEntidades] = useState([])
    const [checkedResponsableEntidad, setCheckedResponsableEntidad] = useState(false);
    const [openMensaje, setOpenMensaje] = useState(false);
    const [openMensaje2, setOpenMensaje2] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')

    const cargarDatosTabla = async () => {
        let entidadesIterar = []
        let entidadesBuscar = []
        let entidadesLeidas = []

        if (esJefe) {

            entidadesIterar.push(await leerEntidadUsuario(sessionStorage.getItem('idEntidad')))
        }
        if (esAsistente) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/division/${idResponsable}/${sessionStorage.getItem('idEntidad')}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })

            entidadesLeidas = await res.json()
            setEntidades(entidadesLeidas)
            entidadesIterar = entidadesLeidas
            // console.log(`\n\n ENTIDADES ${JSON.stringify(entidadesIterar)}\n\n`)
        }

        let avisos = []
        //let avisosPlaneacion = []

        await Promise.all(
            entidadesIterar.map(async (entidad) => {
                //console.log(`\nITERANDO ENTIDADES ${JSON.stringify(entidad)}`)
                const resAvisosGestion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos/gestion/${entidad.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const avisosGestionLeidos = await resAvisosGestion.json()
                //console.log(`avisosGestionLeidos ${JSON.stringify(avisosGestionLeidos)}`)

                avisos = avisos.concat(avisosGestionLeidos)

                const resAvisosPlaneacion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos/planeacion/${entidad.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const avisosPlaneacionLeidos = await resAvisosPlaneacion.json()

                avisos = avisos.concat(avisosPlaneacionLeidos)
                entidadesBuscar.push(entidad.nombre)

            })
        )

        const datosGestion = {
            columns: [
                { field: "texto", width: 350, headerName: "Mensaje", hide: false, sortable: false, filterable: false },
                { field: "responsableAviso", width: 150, headerName: "Publicado por:", hide: false, sortable: true, filterable: true, type: "string" },

                {
                    field: "createdAt", width: 150, headerName: "Fecha", hide: false, sortable: true, filterable: true, type: "date", renderCell: ({ value }) => (
                        (new Date(value)).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" })
                    )
                },
                {
                    field: "entidad", width: 150, headerName: "Entidad", hide: false, sortable: true, filterable: true, type: "singleSelect", "valueOptions": entidadesBuscar
                },
                {
                    field: "tipo", width: 130, headerName: "Tipo", hide: false, sortable: true, filterable: true, type: "singleSelect", "valueOptions": tiposBuscar, renderCell: ({ value, row }) => (<>{tipos.filter(tipos => tipos.id === value)[0] ? tipos.filter(tipos => tipos.id === value)[0].label : null}&nbsp;</>)
                },
                {
                    field: "id", width: 150, align: 'center', sortable: false, filterable: false,
                    headerName: 'Eliminar',
                    renderCell: ({ value }) => (
                        value ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(value)}>Eliminar</Button> : <></>
                    ),
                }
            ], rows: avisos

        }
        setDataGestion(datosGestion)
    }

    const handleDelete = async (id) => {

        try {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                if (res.status === 403) {
                    setOpenMensaje2(true)
                    setSeverity('warning')
                    setMensaje(`La sesión ha expirado, cierre su sesión (Botón LOGOUT) y vuelva a loguearse`)
                    return
                }
            await cargarDatosTabla()
        } catch (error) {
            console.error(error)
        }

    }

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleChecked = (event) => {
        setCheckedResponsableEntidad(event.target.checked);
    };

    const limpiarFormulario = () => {
        setAviso({ ...aviso, 'texto': '' })

        if (document.getElementById('entidad')) {
            setEntidadesSeleccionadas([])
            document.getElementById('entidad').value = []
        }
        const forma = document.getElementById('formaAviso')
        if (forma)
            forma.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click()
        setTipo({ id: null, label: '' })
        setCheckedResponsableEntidad(false)
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        aviso.tipo = tipo.id
        if (entidadesSeleccionadas.length === 0) {
            aviso.idEntidad = sessionStorage.getItem('idEntidad')
            aviso.idResponsable = usuario.id
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify(aviso)
            })
            const data = await res.json()
            setAviso(data)
            if (res.status === 200) {
                //limpiar toda la forma      
                limpiarFormulario()
                setSeverity('success')
            }
            else
                setSeverity('error')

            if (data.message) {
                setOpenMensaje(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpenMensaje(true)
                setMensaje("Se registró el aviso")
                // setRecargar(true)
                await cargarDatosTabla()
            }
        }
        else {
            await Promise.all(
                entidadesSeleccionadas.map(async (entidad) => {
                    const resUsuario = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/porPerfil/${entidad.idPerfilResponsable}`)
                    const responsable = await resUsuario.json()
                    aviso.idEntidad = entidad.id
                    if (checkedResponsableEntidad)
                        aviso.idResponsable = responsable.id
                    else
                        aviso.idResponsable = usuario.id
                    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": sessionStorage.getItem('token'),
                            "perfil": sessionStorage.getItem('perfil')
                        },
                        body: JSON.stringify(aviso)
                    })
                    const data = await res.json()
                    setAviso(data)
                    if (res.status === 200) {
                        //limpiar toda la forma  
                        limpiarFormulario()
                        setSeverity('success')
                    }
                    else
                        setSeverity('error')
                    if (data.message) {
                        setOpenMensaje(true)
                        setMensaje(data.message)
                        return
                    }
                    else {
                        setOpenMensaje(true)
                        setMensaje("Se registró el aviso")

                        await cargarDatosTabla()
                    }
                })
            )
        }
    }

    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    let count = 1;

    const idResponsable = decoded.id;
    const [aviso, setAviso] = useState({ idSolicitud: null, avisos: null, idResponsable, estado: null })

    const leerEntidadUsuario = async (idEntidad) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${idEntidad}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })

        const entidadLeida = await res.json()
        entidades.push(entidadLeida)
        return entidadLeida
    }

    useEffect(() => {
        (async () => {
            await cargarDatosTabla()
        })();
    }, []
    )

    return (
        <Grid container justifyContent='stretch' spacing={1} style={{ marginTop: 5 }}>
            <Grid item xs={12} sm={12}>
                <Card style={{ height: '100%', width: '100%' }}>
                    <CardHeader title='Avisos vigentes' action={
                        <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white' }} onClick={() => { handleClickOpen() }} >
                            Publicar aviso
                        </Button>
                    }></CardHeader>
                    <CardContent>
                    <Box sx={{ width: '100%' }}>
                                    <Collapse in={openMensaje2}>
                                        <Alert severity={severity}
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenMensaje2(false);
                                                    }}
                                                >
                                                    <CloseIcon fontSize="inherit" />
                                                </IconButton>
                                            }
                                            style={{ marginBottom: 30 }}
                                        >
                                            {mensaje}
                                        </Alert>
                                    </Collapse>
                                </Box>
                        <DataGrid {...dataGestion} pageSize={pageSize} autoHeight getRowHeight={() => 'auto'} getRowId={() => count++} sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 1,
                            },
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                        }}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}>

                        </DataGrid>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} sm={12}>
                <Dialog open={openDialog}>
                    <form onSubmit={handleSubmit} id='formaAviso'>
                        <DialogTitle>Nuevo aviso </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                            </DialogContentText>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                <Grid item xs={12}>
                                    <TextField label='Texto del aviso' id='texto' name='texto' focused required multiline onChange={(event) => {
                                        setAviso({ ...aviso, [event.target.name]: event.target.value })
                                    }} sx={{ width: '100%' }} value={aviso.texto} />
                                </Grid>
                                {esAsistente ?
                                    <Grid item xs={12} sm={12}>
                                        <Autocomplete
                                            multiple
                                            id="entidad"
                                            options={entidades}
                                            getOptionLabel={(option) => option.nombre}
                                            filterSelectedOptions
                                            onChange={async (event, newValue) => {
                                                if (newValue) {
                                                    setEntidadesSeleccionadas(newValue)
                                                    // console.log(`ENTIDADES SELECCIONADAS ${JSON.stringify(newValue)}`)
                                                }
                                                else
                                                    setEntidadesSeleccionadas([])
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Entidad" focused sx={{ width: '100%' }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    : <></>
                                }
                                <Grid item xs={12} sm={12}>
                                    <Autocomplete
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionLabel={(option) => option.label}
                                        value={tipo}
                                        onChange={async (event, newValue) => {
                                            if (newValue)
                                                setTipo(newValue)
                                            else
                                                setTipo({ id: null, label: '' })
                                        }}
                                        id="tipo"
                                        name="tipo"
                                        options={tipos}
                                        renderInput={(params) => <TextField {...params} label={`Tipo`} focused required sx={{ width: '100%' }} />}
                                    />
                                </Grid>
                                {entidadesSeleccionadas.length === 0 ? <></> :
                                    <Grid item xs={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={checkedResponsableEntidad}
                                                onChange={handleChecked} inputProps={{ 'aria-label': 'controlled' }} />}
                                                label="Publicar a nombre del responsable de la entidad" />
                                        </FormGroup>
                                    </Grid>
                                }
                            </Grid>
                            <Grid item sx={{ marginTop: 5 }} xs={12}>
                                <Box sx={{ width: '100%' }}>
                                    <Collapse in={openMensaje}>
                                        <Alert severity={severity}
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenMensaje(false);
                                                    }}
                                                >
                                                    <CloseIcon fontSize="inherit" />
                                                </IconButton>
                                            }
                                            style={{ marginBottom: 30 }}
                                        >
                                            {mensaje}
                                        </Alert>
                                    </Collapse>
                                </Box>
                                <Button variant='contained' color='primary' type='submit' >
                                    Publicar
                                </Button>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cerrar</Button>

                        </DialogActions>
                    </form>
                </Dialog>

            </Grid>
        </Grid>
    );
}